import Icon, { IconProps } from "components/Icons/Icon"
import React from "react"

const LogoutIcon = ({ ...restProps }: IconProps) => (
  <Icon {...restProps} stroke="none" viewBox="0 0 24 24">
    <path
      d="M6.187 8.063 2.25 12l3.937 3.938M12.75 12H2.253M12.75 3.75H18a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-.75.75h-5.25"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
)

export default LogoutIcon
